module.exports = __webpack_public_path__ + "img/vebal.b758e072.svg";